import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/Index'
    },
    // 心护士APP用户指南
    {
      path: '/index',
      name: 'Index',
      component: () => import('./../views/userGuide/index')
    },
    // 医生1：doctor
    {
      path: '/doctorOne',
      name: 'DoctorOne',
      component: () => import('./../views/doctorOne/index')
    },
    // 医生2：doctor
    {
      path: '/doctorTwo',
      name: 'DoctorTwo',
      component: () => import('./../views/doctorTwo/index')
    },
    // 心护士1：personage
    {
      path: '/personageOne',
      name: 'PersonageOne',
      component: () => import('./../views/personageOne/index')
    },
    // 心护士2：personage
    {
      path: '/personageTwo',
      name: 'PersonageTwo',
      component: () => import('./../views/personageTwo/index')
    },
    // 数字人1：digitalPeople
    {
      path: '/digitalPeopleOne',
      name: 'DigitalPeopleOne',
      component: () => import('./../views/digitalPeopleOne/index')
    },
    // 数字人2：digitalPeople
    {
      path: '/digitalPeopleTwo',
      name: 'DigitalPeopleTwo',
      component: () => import('./../views/digitalPeopleTwo/index')
    },
    // 前途无忧1：education
    {
      path: '/educationOne',
      name: 'EducationOne',
      component: () => import('./../views/educationOne/index')
    },
    // 前途无忧2：education
    {
      path: '/educationTwo',
      name: 'EducationTwo',
      component: () => import('./../views/educationTwo/index')
    },
    {
      path: '/policyAgreementTemplate',
      name: 'PolicyAgreement',
      component: () => import('./../views/policyAgreementTemplate/index')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js